/** The different types of achievements which can be given to projects */

const AchievementTypes = {
    trackPlacement: {
        id: 'trackPlacement',
        label: 'Track Placement',
    },
    challengePlacement: {
        id: 'challengePlacement',
        label: 'Challenge Placement',
    },
    overallPlacement: {
        id: 'overallPlacement',
        label: 'Overall Placement',
    },
    finalist: {
        id: 'finalist',
        label: 'Finalist',
    },
}

module.exports = AchievementTypes
